import { render } from "./submitArcade.vue?vue&type=template&id=1b98bc68&scoped=true"
import script from "./submitArcade.vue?vue&type=script&lang=js"
export * from "./submitArcade.vue?vue&type=script&lang=js"

import "./submitArcade.vue?vue&type=style&index=0&id=1b98bc68&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b98bc68"]])

export default __exports__